import { record } from '../utils/recorder';
import { BaseShapeMutationAPI } from './base-shape-mutation-api';
import type { IConnectorData } from '../data';
import type { ConnectorDataModel } from '../model/connector-data-model';
import type { DeltaOf } from '../utils/delta';

export class ConnectorMutationAPI extends BaseShapeMutationAPI<ConnectorDataModel> {
    /**
     * 更新连接线属性
     */
    @record()
    public updateProps({ spPr, nvPr, style }: DeltaOf<IConnectorData>) {
        return super.updateProps({
            spPr,
            nvPr: nvPr && {
                ...super.getCommonNonVisualPropsDelta(nvPr),
                connector: {
                    stCxn: nvPr.stCxn,
                    endCxn: nvPr.endCxn,
                },
            },
            style,
        });
    }
}
